<template>
  <div class="brains-file-input-container">
    <label :for="fileId" class="file-input-fake-input">
      <div class="container-text">
        {{ $t("select-file") }}
      </div>
      <div class="container-file-name">
        <div v-if="!file">{{ $t("no-file-selected") }}</div>
        <div v-else>{{ file.name }}</div>
      </div>
    </label>
    <input :id="fileId" :ref="'file-' + fileId" type="file" class="" :accept="accept" hidden @change="handleFileUpload()">
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: {
      default: null
    },
    accept: {
      default: '.*'
    }
  },
  data() {
    return {
      file: false,
      randomNum: 0
    }
  },
  computed: {
    fileId() {
      return 'brains-file-input-' + this.randomNum
    }
  },
  watch: {
    value() {
      this.file = this.value
    },
    file() {
      this.handleInput()
    }
  },
  mounted() {
    this.generateRandomNum()
  },
  methods: {
    generateRandomNum() {
      this.randomNum = Math.floor(Date.now() * (9999 - 0)) + 0
    },
    handleFileUpload() {
      this.file = this.$refs['file-' + this.fileId].files[0]
    },
    handleInput() {
      this.$emit('input', this.file)
    }
  }
}
</script>
<style lang="scss" scoped>
.brains-file-input-container {
  width: 100%;

  .file-input-fake-input {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgb(194, 194, 194);
    border-radius: 15px;
    overflow: hidden;
    height: 33px;

    & > div {
      font-family: "Montserrat-SemiBold",sans-serif;
      color: black;
      font-size: 13px;
      cursor: pointer;
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 5px;

      & > div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .container-text {
      background-color: rgb(240, 240, 240);
    }
  }
}
</style>
